import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import publicAPIServices from '../../services/publicAPIServices';

const initialState = {
  data: [],
  loading: false,
  error: false,
  success: false,
  message: ''
};

// fetch

export const fetchTurnsData = createAsyncThunk('turns/fetch', async (url, thunkAPI) => {
  try {
    return await publicAPIServices.fetchData(url);
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const turnsSlice = createSlice({
  name: 'turns',
  initialState,
  reducers: {
    reset: (state) => {
      state.loading = false;
      state.success = false;
      state.error = false;
      state.message = '';
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTurnsData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTurnsData.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
      })
      .addCase(fetchTurnsData.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.message = action.payload;
        state.data = null;
      });
  }
});

export const { reset } = turnsSlice.actions;
export default turnsSlice.reducer;
